// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__q0Ez2","fileBtn":"File_fileBtn__331cO","closeBtn":"File_closeBtn__10qG6","fileSelected":"File_fileSelected__2ct3e","disabled":"File_disabled__1RzU4"};